export const DEPLOYMENT_ROUTE_SECTIONS = [
  "dashboard",
  "live",
  "analytics",
  "notifications",
  "playback",
  "settings",
  "help",
] as const;

export type DeploymentRouteSection = (typeof DEPLOYMENT_ROUTE_SECTIONS)[number];

const DEPLOYMENT_ROUTE_SECTION_SET = new Set<string>(DEPLOYMENT_ROUTE_SECTIONS);

export function createDeploymentRoutePath(
  deploymentId: string,
  section: DeploymentRouteSection = "dashboard"
): string {
  return `/deployments/${encodeURIComponent(deploymentId)}/${section}`;
}

export function getDeploymentRouteSection(pathname: string): DeploymentRouteSection {
  const match = /^\/deployments\/[^/]+\/([^/?#]+)/.exec(pathname);
  const section = match?.[1];

  if (section && DEPLOYMENT_ROUTE_SECTION_SET.has(section)) {
    return section as DeploymentRouteSection;
  }

  return "dashboard";
}
